import { eventDataToLimits } from './limits.utils';
import { ILimit } from '../../interfaces';
import { ILimitsService } from './limits.interface';
import { inject, injectable } from 'inversify';
import {
    ISSEForLimitsService,
    SSE_FOR_LIMITS_SERVICE,
} from '../sse-for-limits';
import { Observable, Subject } from 'rxjs';

@injectable()
export class LimitsService implements ILimitsService {

    private obs$: Subject<Array<ILimit>>;

    @inject(SSE_FOR_LIMITS_SERVICE) private readonly sseSrv: ISSEForLimitsService;

    asObservable(): Observable<Array<ILimit>> {
        if (!Boolean(this.obs$)) {
            this.init();
        }

        return this.obs$.asObservable();
    }

    private init(): void {
        this.obs$ = new Subject<Array<ILimit>>();

        this.sseSrv.addEventListener('LIMIT_STATUS_INITIALIZATION', (event: MessageEvent) => {
            this.obs$.next(eventDataToLimits(event));
        });

        this.sseSrv.addEventListener('LIMIT_STATUS_UPDATE', (event: MessageEvent) => {
            this.obs$.next(eventDataToLimits(event));
        });

        this.sseSrv.init();
    }
}
